let currentPlayer = null;
const players = new Map();

const videoManager = {
  currentPlayer: null,
  players: new Map(),

  pauseAllVideos: (exceptPlayer = null) => {
    players.forEach((player, element) => {
      if (!element || element === exceptPlayer) return;

      try {
        if (element.tagName === 'IFRAME') {
          const ytPlayer = players.get(element);
          if (ytPlayer && ytPlayer.pauseVideo) {
            ytPlayer.pauseVideo();
          }
        } else if (element.tagName === 'VIDEO') {
          if (!element.paused) {
            element.pause();
          }
        }
      } catch (e) {
        console.error('Error pausing video:', e);
      }
    });
  },

  addPlayer: (element, player) => {
    if (!element) return;
    players.set(element, player);
  },

  removePlayer: element => {
    if (!element) return;

    try {
      if (element.tagName === 'IFRAME') {
        const player = players.get(element);
        if (player && player.destroy) {
          player.destroy();
        }
      } else if (element.tagName === 'VIDEO') {
        if (!element.paused) {
          element.pause();
        }
      }
      players.delete(element);
      if (currentPlayer === element) {
        currentPlayer = null;
      }
    } catch (e) {
      console.error('Error removing player:', e);
    }
  },

  isPlaying: element => {
    if (!element) return false;

    try {
      if (element.tagName === 'IFRAME') {
        const player = players.get(element);
        return player && player.getPlayerState && player.getPlayerState() === 1;
      } else if (element.tagName === 'VIDEO') {
        return !element.paused;
      }
      return false;
    } catch (e) {
      console.error('Error checking if video is playing:', e);
      return false;
    }
  },

  pauseCurrentVideo: () => {
    if (!currentPlayer) return;

    try {
      const element = currentPlayer;
      if (element.tagName === 'IFRAME') {
        const player = players.get(element);
        if (player && player.pauseVideo) {
          player.pauseVideo();
        }
      } else if (element.tagName === 'VIDEO') {
        if (!element.paused) {
          element.pause();
        }
      }
      currentPlayer = null;
    } catch (e) {
      console.error('Error pausing current video:', e);
    }
  },

  setCurrentPlayer: element => {
    currentPlayer = element;
  },
};

const initYouTubeAPI = () => {
  if (!window.YT) {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
};

const createPlayer = (element, videoId) => {
  if (!element || !window.YT || !window.YT.Player) return null;

  const player = new window.YT.Player(element, {
    videoId: videoId,
    playerVars: {
      enablejsapi: 1,
      origin: window.location.origin,
      autoplay: 0,
      controls: 1,
      modestbranding: 1,
      rel: 0,
      playsinline: 1,
      fs: 1,
    },
    events: {
      onReady: event => {
        setupObserver(element, event.target);
      },
      onStateChange: event => {
        if (event.data === window.YT.PlayerState.PLAYING) {
          videoManager.pauseAllVideos(element);
          videoManager.setCurrentPlayer(element);
        } else if (event.data === window.YT.PlayerState.PAUSED || event.data === window.YT.PlayerState.ENDED) {
          if (currentPlayer === element) {
            currentPlayer = null;
          }
        }
      },
    },
  });

  videoManager.addPlayer(element, player);
  return player;
};

const setupObserver = (element, player) => {
  if (!element) return;

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          if (element.tagName === 'IFRAME') {
            if (player && player.pauseVideo) {
              player.pauseVideo();
            }
          } else if (element.tagName === 'VIDEO') {
            if (!element.paused) {
              element.pause();
            }
          }
          if (currentPlayer === element) {
            currentPlayer = null;
          }
        }
      });
    },
    {
      threshold: 0.5,
      rootMargin: '0px',
    },
  );

  observer.observe(element);
  return observer;
};

export { videoManager, initYouTubeAPI, createPlayer, setupObserver };
